import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=ae36fa84"
import script from "./AcceptInvitation.vue?vue&type=script&lang=ts"
export * from "./AcceptInvitation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae36fa84')) {
      api.createRecord('ae36fa84', component.options)
    } else {
      api.reload('ae36fa84', component.options)
    }
    module.hot.accept("./AcceptInvitation.vue?vue&type=template&id=ae36fa84", function () {
      api.rerender('ae36fa84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/AcceptInvitation.vue"
export default component.exports